export class PasswordVerificationRequest {
    masterPasswordHash: string;
}
